export default __webpack_public_path__ + "static/media/frontEntrance.31493e25.jpg";